import { FollowupResponseItem as FollowupResponseItemType } from '../../../types/conversation';
import ReportRenderer from '../../ReportRenderer';

interface FollowupResponseItemProps {
  item: FollowupResponseItemType;
}

export function FollowupResponseItem({ item }: FollowupResponseItemProps) {
  // Hide streaming placeholder when empty - progress block shows the status
  if (item.isStreaming && !item.content) {
    return null;
  }

  // Both streaming and completed states use ReportRenderer for proper markdown formatting
  return (
    <div className="flex justify-start">
      <div className={`max-w-[85%] rounded-2xl rounded-tl-sm px-4 py-3 bg-slate-100 dark:bg-slate-700 ${item.isStreaming ? 'animate-pulse' : ''}`}>
        {item.isStreaming && (
          <div className="flex items-center gap-2 mb-2 text-purple-600 dark:text-purple-400">
            <svg className="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
            </svg>
            <span className="text-sm font-medium">Generowanie odpowiedzi...</span>
          </div>
        )}
        <ReportRenderer markdown={item.content} />
        {!item.isStreaming && item.tokensUsed && (
          <p className="text-xs mt-2 text-slate-500 dark:text-slate-400">{item.tokensUsed} tokenów</p>
        )}
      </div>
    </div>
  );
}

export default FollowupResponseItem;
